module.exports = __webpack_public_path__ + "static/media/FOS_Logo_withBG.0e4816de.png";